/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-debug-toolbar/webhook-debug-toolbar.component.scss */
::ng-deep .ant-float-btn-body .ant-float-btn-content .ant-float-btn-icon {
  margin-right: 6px;
  font-size: 24px;
}
::ng-deep .publish-bg .ant-float-btn-body {
  background-color: color-mix(in srgb, var(--tem-success) 18%, var(--tem-surface)) !important;
}
::ng-deep .copy-bg .ant-float-btn-body {
  background-color: color-mix(in srgb, var(--tem-deep) 14%, var(--tem-surface)) !important;
}
::ng-deep .disabled-float-btn .ant-float-btn-body {
  background-color: var(--tem-border) !important;
  color: var(--tem-muted) !important;
}
.disabled-float-btn {
  pointer-events: none;
  cursor: not-allowed;
}
nz-float-button-group,
nz-float-button {
  position: absolute;
}
.font-icon {
  width: 24px;
  font-size: 24px;
}
.publish-icon {
  color: var(--tem-success);
}
.start-icon {
  color: var(--tem-deep);
}
.stop-icon {
  color: var(--tem-danger);
}
.disable-icon {
  color: var(--tem-muted) !important;
}
.variable-icon {
  color: var(--tem-deep);
}
/*# sourceMappingURL=webhook-debug-toolbar.component.css.map */
